import React from "react";
import { cn } from "../../lib/utils";

const MoneyCell = ({
  value,
  currency = "د.إ",
  locale = "ar-AE",
  className = "",
  tone = "neutral",
}) => {
  const amount = Number(value || 0);
  const tones = {
    neutral: "text-neutral-900 dark:text-neutral-100",
    success: "text-success-700 dark:text-success-300",
    danger: "text-danger-700 dark:text-danger-300",
    warning: "text-warning-700 dark:text-warning-300",
  };
  return (
    <span
      className={cn(
        "inline-flex w-full items-baseline justify-end gap-1 font-mono tabular-nums",
        tones[tone] || tones.neutral,
        className,
      )}
      dir="ltr"
    >
      <span>
        {new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format(
          amount,
        )}
      </span>
      {currency && (
        <span className="font-sans text-xs text-neutral-500 dark:text-neutral-400">
          {currency}
        </span>
      )}
    </span>
  );
};

export default MoneyCell;
